import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (currentPage, perPage, search) => {
  return await GET(
    `/admin/rummy/rummy-point-master?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}`,
  );
};

export const findOne = async (id) => {
  return await GET(`/admin/rummy/rummy-point-master/${id}`);
};

export const Create = async (data) => {
  return await POST(`/admin/rummy/rummy-point-master`, data);
};

export const Update = async (id, data) => {
  return await PUT(`/admin/rummy/rummy-point-master/${id}`, data);
};

export const Status = async (id) => {
  return await POST(`/admin/rummy/rummy-point-master/${id}`);
};

export const Delete = async (id) => {
  return await DELETE(`/admin/rummy/rummy-point-master/${id}`);
};
